export const summaryPageTopMenu = {
	intro: { id: 'intro', text: 'Intro', path: '#intro', icon: 'Vrpano', subMenu: null },
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap Components',
		path: '#bootstrap',
		icon: 'BootstrapFill',
		subMenu: null,
	},
	storybook: {
		id: 'storybook',
		text: 'Storybook',
		path: '#storybook',
		icon: 'CustomStorybook',
		subMenu: null,
	},
	formik: {
		id: 'formik',
		text: 'Formik',
		path: '#formik',
		icon: 'CheckBox',
		subMenu: null,
	},
	apex: {
		id: 'apex',
		text: 'Apex Charts',
		path: '#apex',
		icon: 'AreaChart',
		subMenu: null,
	},
};

export const dashboardPagesMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		// text: 'SREZ PURCHASE MANAGER',
		path: '/',
		icon: 'Dashboard',
		subMenu: null,
	},

	attendanceRequest: {
		id: 'attendanceRequest',
		parentModule: 'hrm',
		text: 'Attendance Request',
		path: '/attendanceRequest',
		icon: 'ScheduleSend',
		subMenu: null,
	},

	monthlyAttendance: {
		id: 'monthlyAttendance',
		text: 'Monthly Attendance',
		path: '/monthlyAttendance',
		icon: 'CalendarToday',
		subMenu: null,
	},

	analyticsPage: {
		id: 'analytics',
		text: 'Analytics',
		path: 'analytics',
		icon: 'Analytics',
		// notification: true,
		subMenu: null,
		hide: true,
	},

	accountPage: {
		id: 'account',
		text: 'Account',
		path: 'account',
		icon: 'ManageAccounts',
		// notification: true,
		subMenu: {
			createAccount: {
				id: 'createAccount',
				parentModule: 'account',
				text: 'Create Account',
				path: 'account/create',
				icon: 'add',
			},
			editAccount: {
				id: 'createEdit',
				parentModule: 'account',
				text: 'Create Edit',
				path: 'account/edit/:id',
				icon: 'edit',
				hide: true,
			},
			detailAccount: {
				id: 'createDetail',
				parentModule: 'account',
				text: 'Create Detail',
				path: 'account/detail/:id',
				icon: 'add',
				hide: true,
			},
		},
	},

	companyPage: {
		id: 'company',
		text: 'Company',
		path: 'company',
		icon: 'Business',
		// notification: true,
		subMenu: {
			createCompany: {
				id: 'createCompany',
				parentModule: 'company',
				text: 'Create Company',
				path: 'company/create',
				icon: 'add',
			},
			editCompany: {
				id: 'updateCompany',
				parentModule: 'company',
				text: 'Update Company',
				path: 'company/update/:id',
				icon: 'edit',
				hide: true,
			},
			detailCompany: {
				id: 'detailCompany',
				parentModule: 'company',
				text: 'Detail Company',
				path: 'company/detail/:id',
				icon: 'add',
				hide: true,
			},
		},
	},

	productPages: {
		id: 'product',
		text: 'Product',
		path: 'product',
		icon: 'listAlt',
		subMenu: {
			createProduct: {
				id: 'createProduct',
				parentModule: 'product',
				text: 'Create Product',
				path: 'product/create',
				icon: 'add',
			},
			editProduct: {
				id: 'editProduct',
				parentModule: 'product',
				text: 'edit Product',
				path: 'product/edit/:id',
				icon: 'edit',
				hide: true,
			},
			detailProduct: {
				id: 'detailProduct',
				parentModule: 'product',
				text: 'Detail Product',
				path: 'product/detail/:id',
				icon: 'add',
				hide: true,
			},
			productCategoryPages: {
				id: 'category',
				parentModule: 'category',
				text: 'Product Category',
				path: 'product/category',
				icon: 'category',
				subMenu: {
					// listCategory: {
					// 	id: 'listCategory',
					// 	text: 'List Category',
					// 	path: 'category',
					// 	icon: 'ViewDay',
					// },
					createCategory: {
						id: 'createCategory',
						parentModule: 'category',
						text: 'Create Category',
						path: 'product/category/create',
						icon: 'add',
					},
					editCategory: {
						id: 'editCategory',
						parentModule: 'category',
						text: 'edit Category',
						path: 'product/category/edit/:id',
						icon: 'edit',
						hide: true,
					},
				},
			},

			productUnitPages: {
				id: 'product_unit',
				parentModule: 'product_unit',
				text: 'Product Unit',
				path: 'product/unit',
				icon: 'adUnits',
				subMenu: {
					// listUnit: {
					// 	id: 'listUnit',
					// 	text: 'List Unit',
					// 	path: 'unit',
					// 	icon: 'ViewDay',
					// },
					createUnit: {
						id: 'createUnit',
						parentModule: 'product_unit',
						text: 'Create Unit',
						path: 'product/unit/create',
						icon: 'add',
					},
					editUnit: {
						id: 'editUnit',
						parentModule: 'product_unit',
						text: 'Create Unit',
						path: 'product/unit/edit/:id',
						icon: 'edit',
						hide: true,
					},
				},
			},
		},
	},

	requisitionPage: {
		id: 'requisition',
		text: 'Requisition',
		path: 'requisitions',
		icon: 'Settings',
		// notification: true,
		subMenu: {
			createRequisition: {
				id: 'createRequisition',
				parentModule: 'requisition',
				text: 'Create Requisition',
				path: 'requisitions/create',
				icon: 'add',
			},
			detailsRequisition: {
				id: 'detailsRequisition',
				parentModule: 'requisition',
				text: 'Details Requisition',
				path: 'requisitions/detail/:id',
				icon: 'detail',
				hide: true,
			},
			editRequisition: {
				id: 'editRequisition',
				parentModule: 'requisition',
				text: 'Update Requisition',
				path: 'requisitions/edit/:id',
				icon: 'add',
				hide: true,
			},
		},
	},

	//PurchaseIndent
	purchaseIndentPage: {
		id: 'purchase_indent',
		text: 'Purchase Indent',
		path: 'purchase_indent',
		icon: 'ShoppingBasket',
		// notification: true,
		subMenu: {
			createPurchaseIndent: {
				id: 'createPurchaseIndent',
				parentModule: 'purchase_indent',
				text: 'Create PurchaseIndent',
				path: 'purchase_indent/create',
				icon: 'add',
			},
			editPurchaseIndent: {
				id: 'createEditIndent',
				parentModule: 'purchase_indent',
				text: 'Create Edit Indent',
				path: 'purchase_indent/edit/:id',
				icon: 'edit',
				hide: true,
			},
			detailPurchaseIndent: {
				id: 'createDetail Indent',
				parentModule: 'purchase_indent',
				text: 'Create Detail Indent',
				path: 'purchase_indent/detail/:id',
				icon: 'add',
				hide: true,
			},
		},
	},

	confirmIndentPage: {
		id: 'purchase_indent',
		parentModule: 'purchase_indent',
		text: 'Confirmed PI',
		path: 'confirmed',
		icon: 'ShoppingBasket',
		// notification: true,
		subMenu: null,
	},

	quotationPage: {
		id: 'quotation',
		text: 'Quotation',
		path: 'quotation',
		icon: 'RequestQuote',
		subMenu: {
			createQuotation: {
				id: 'createQuotation',
				parentModule: 'quotation',
				text: 'Create Quotation',
				path: 'quotation/create',
				icon: 'add',
			},
			editQuotation: {
				id: 'editQuotation',
				parentModule: 'quotation',
				text: 'Edit Quotation',
				path: 'quotation/update/:id',
				icon: 'edit',
				hide: true,
			},
			detailQuotation: {
				id: 'detailQuotation',
				parentModule: 'quotation',
				text: 'Detail Quotation',
				path: 'quotation/detail/:id',
				icon: 'add',
				hide: true,
			},
		},
	},

	//PurchaseOrder
	purchaseOrderPage: {
		id: 'purchase_order',
		text: 'Purchase Order',
		path: 'purchaseOrder',
		icon: 'Storefront',
		// notification: true,
		subMenu: {
			// listPurchaseOrder: {
			// 	id: 'PurchaseOrder',
			// 	text: 'Purchase Order',
			// 	path: 'purchaseOrder',
			// 	icon: 'ViewDay',
			// },
			createPurchaseOrder: {
				id: 'createPurchaseOrder',
				parentModule: 'purchase_order',
				text: 'Create Purchase Order',
				path: 'purchaseOrder/create',
				icon: 'add',
			},
			editPurchaseOrder: {
				id: 'createEdit',
				parentModule: 'purchase_order',
				text: 'Create Edit',
				path: 'purchaseOrder/edit/:id',
				icon: 'edit',
				hide: true,
			},
			detailPurchaseOrder: {
				id: 'createDetail',
				parentModule: 'purchase_order',
				text: 'Detail Purchase Order',
				path: 'purchaseOrder/detail/:id',
				icon: 'add',
				hide: true,
			},
		},
	},

	// PO close approval
	purchaseOrderRequestPage: {
		id: 'purchase_order_request',
		text: 'PO Request',
		path: 'purchaseOrderRequest',
		icon: 'Storefront'
	},

	modifyPurchaseOrderPage: {
		id: 'po_modify_request',
		text: 'Modify PO Request',
		path: 'modifyPurchaseOrder',
		icon: 'Storefront',
		subMenu: {
			createManualModifyPurchaseOrder: {
				id: 'createManualModifyPurchaseOrder',
				parentModule: 'po_modify_request',
				text: 'Request Modify PO',
				path: 'modifyPurchaseOrder/create/:id',
				icon: 'add',
				hide: true,
			},
			createModifyPurchaseOrder: {
				id: 'createModifyPurchaseOrder',
				parentModule: 'po_modify_request',
				text: 'Request Modify PO',
				path: 'modifyPurchaseOrder/create',
				icon: 'add',
			},
			editModifyPurchaseOrder: {
				id: 'createEdit',
				parentModule: 'po_modify_request',
				text: 'Create Edit',
				path: 'modifyPurchaseOrder/edit/:id',
				icon: 'edit',
				hide: true,
			},
			detailModifyPurchaseOrder: {
				id: 'createDetail',
				parentModule: 'po_modify_request',
				text: 'Modified PO Detail',
				path: 'modifyPurchaseOrder/detail/:id',
				icon: 'add',
				hide: true,
			},
		},
	},
	modifyPurchaseOrderRequestPage: {
		id: 'po_modify_request',
		parentModule: 'po_modify_request',
		text: 'Modified PO',
		path: 'listPOModificationRequests',
		icon: 'Storefront',
		subMenu: null,
	},

	grnPages: {
		id: 'grn',
		text: 'GRN (Challan)',
		path: 'grn',
		icon: 'ReceiptLong',
		subMenu: {
			// listGrn: {
			// 	id: 'listGrn',
			// 	text: 'List GRN',
			// 	path: 'grn',
			// 	icon: 'ViewDay',
			// },
			createGrn: {
				id: 'creategrn',
				parentModule: 'grn',
				text: 'Create GRN',
				path: 'grn/create',
				icon: 'add',
			},
			editGrn: {
				id: 'editgrn',
				parentModule: 'grn',
				text: 'Edit GRN',
				path: 'grn/update/:id',
				icon: 'add',
				hide: true,
			},
			detailsGrn: {
				id: 'detailsgrn',
				parentModule: 'grn',
				text: 'Details GRN',
				path: 'grn/detail/:id',
				icon: 'detail',
				hide: true,
			},
		},
	},

	purchasePages: {
		id: 'purchase_bill',
		text: 'Purchase Bill',
		path: 'purchase',
		icon: 'ShoppingBag',
		subMenu: {
			// listPurchase: {
			// 	id: 'listPurchase',
			// 	text: 'List Purchase Bill',
			// 	path: 'purchase',
			// 	icon: 'ViewDay',
			// },
			createPurchase: {
				id: 'createPurchase',
				parentModule: 'purchase_bill',
				text: 'Create Purchase Bill',
				path: 'purchase/create',
				icon: 'add',
			},
			editPurchase: {
				id: 'editPurchase',
				parentModule: 'purchase_bill',
				text: 'edit Purchase Bill',
				path: 'purchase/edit/:id',
				icon: 'edit',
				hide: true,
			},
			detailsPurchase: {
				id: 'detailsPurchase',
				parentModule: 'purchase_bill',
				text: 'details Purchase Bill',
				path: 'purchase/detail/:id',
				icon: 'detail',
				hide: true,
			},
		},
	},

	//Payemnt Page
	paymentPage: {
		id: 'payment',
		text: 'Payment',
		path: 'payment',
		icon: 'Payment',
		// notification: true,
		subMenu: {
			createPayment: {
				id: 'createPayment',
				parentModule: 'payment',
				text: 'Create Payment',
				path: 'payment/create',
				icon: 'add',
				hide: false,
			},
			editPayment: {
				id: 'editPayment',
				parentModule: 'payment',
				text: 'Edit Payment',
				path: 'payment/edit/:id',
				icon: 'edit',
				hide: true,
			},
			detailPayment: {
				id: 'detailPayment',
				parentModule: 'payment',
				text: 'Detail Payment',
				path: 'payment/detail/:id',
				icon: 'add',
				hide: true,
			},
			paymentTypePage: {
				id: 'payment_type',
				text: 'Payment Type',
				path: 'payment/paymentType',
				icon: 'AccountBalance',
				// notification: true,
				subMenu: {
					createPaymentType: {
						id: 'createPaymentType',
						parentModule: 'payment_type',
						text: 'Create Payment Type',
						path: 'payment/paymentType/create',
						icon: 'add',
						hide: false,
					},
					editPaymentType: {
						id: 'editPaymentType',
						parentModule: 'payment_type',
						text: 'Edit Payment Type',
						path: 'payment/paymentType/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailPaymentType: {
						id: 'detailPaymentType',
						parentModule: 'payment_type',
						text: 'Detail Payment Type',
						path: 'payment/paymentType/detail/:id',
						icon: 'add',
						hide: true,
					},
				},
			},
			paymentStepPage: {
				id: 'payment_step',
				text: 'Payment Steps',
				path: 'payment/paymentSteps',
				icon: 'PointOfSale',
				// notification: true,
				subMenu: {
					createPaymentStep: {
						id: 'createPaymentStep',
						parentModule: 'payment_step',
						text: 'Create Payment Step',
						path: 'payment/paymentSteps/create',
						icon: 'add',
						hide: false,
					},
					editPaymentStep: {
						id: 'editPaymentStep',
						parentModule: 'payment_step',
						text: 'Edit Payment Step',
						path: 'payment/paymentSteps/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailPaymentStep: {
						id: 'detailPaymentStep',
						parentModule: 'payment_step',
						text: 'Detail Payment Step',
						path: 'payment/paymentSteps/detail/:id',
						icon: 'add',
						hide: true,
					},
				},
			},
			paymentTermsPage: {
				id: 'payment_term',
				text: 'Payment Terms',
				path: 'payment/paymentTerms',
				icon: 'CreditScore',
				// notification: true,
				subMenu: {
					createPaymentTerms: {
						id: 'createPaymentTerms',
						parentModule: 'payment_term',
						text: 'Create Payment Terms',
						path: 'payment/paymentTerms/create',
						icon: 'add',
						hide: false,
					},
					editPaymentTerms: {
						id: 'editPaymentTerms',
						parentModule: 'payment_term',
						text: 'Edit Payment Terms',
						path: 'payment/paymentTerms/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailPaymentTerms: {
						id: 'detailPaymentTerms',
						parentModule: 'payment_term',
						text: 'Detail Payment Terms',
						path: 'payment/paymentTerms/detail/:id',
						icon: 'add',
						hide: true,
					},
				},
			},
			paymentVerificationPage: {
				id: 'payment_verification',
				text: 'Cheque Verification',
				path: 'payment/paymentVerification',
				icon: 'VerifiedUser',
				// notification: true,
				subMenu: {
					createPaymentVerification: {
						id: 'createPaymentVerification',
						text: 'Create Cheque Verification',
						parentModule: 'payment_verification',
						path: 'payment/paymentVerification/create',
						icon: 'add',
						hide: false,
					},
					editPaymentVerification: {
						id: 'editPaymentVerification',
						text: 'Edit Cheque Verification',
						parentModule: 'payment_verification',
						path: 'payment/paymentVerification/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailPaymentVerification: {
						id: 'detailPaymentVerification',
						text: 'Detail Cheque Verification',
						parentModule: 'payment_verification',
						path: 'payment/paymentVerification/detail/:id',
						icon: 'add',
						hide: true,
					},
				},
			},
			quickPaymentPage: {
				id: 'quick_payment',
				text: 'Quick Payment',
				path: 'payment/quickPayment',
				icon: 'VerifiedUser',
				// notification: true,
				subMenu: {
					createQuickPayment: {
						id: 'createQuickPayment',
						text: 'Create Quick Payment',
						parentModule: 'quick_payment',
						path: 'payment/quickPayment/create',
						icon: 'add',
						hide: false,
					},
					editQuickPayment: {
						id: 'editQuickPayment',
						text: 'Edit Quick Payment',
						parentModule: 'quick_payment',
						path: 'payment/quickPayment/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailQuickPayment: {
						id: 'detailQuickPayment',
						text: 'Detail Quick Payment',
						parentModule: 'quick_payment',
						path: 'payment/QuickPayment/detail/:id',
						icon: 'add',
						hide: true,
					},
				},
			},
		},
		// hide: false,
	},

	//Payment Step Page
	// paymentStepPage: {
	// 	id: 'paymentSteps',
	// 	text: 'Payment Steps',
	// 	path: 'paymentSteps',
	// 	icon: 'PointOfSale',
	// 	// notification: true,
	// 	subMenu: {
	// 		// listPaymentStep: {
	// 		// 	id: 'listPaymentSteps',
	// 		// 	text: 'List Payment Steps',
	// 		// 	path: 'paymentStep',
	// 		// 	icon: 'ViewDay',
	// 		// },
	// 		createPaymentStep: {
	// 			id: 'createPaymentStep',
	// 			text: 'Create Payment Step',
	// 			path: 'paymentSteps/create',
	// 			icon: 'add',
	// 			hide: false,
	// 		},
	// 		editPaymentStep: {
	// 			id: 'editPaymentStep',
	// 			text: 'Edit Payment Step',
	// 			path: 'paymentSteps/edit/:id',
	// 			icon: 'edit',
	// 			hide: true,
	// 		},
	// 		detailPaymentStep: {
	// 			id: 'detailPaymentStep',
	// 			text: 'Detail Payment Step',
	// 			path: 'paymentSteps/detail/:id',
	// 			icon: 'add',
	// 			hide: true,
	// 		},
	// 	},
	// 	hide: false,
	// },

	//Payment Terms Page
	// paymentTermsPage: {
	// 	id: 'paymentTerms',
	// 	text: 'Payment Terms',
	// 	path: 'paymentTerms',
	// 	icon: 'CreditScore',
	// 	// notification: true,
	// 	subMenu: {
	// 		// listPaymentTerms: {
	// 		// 	id: 'listPaymentTerms',
	// 		// 	text: 'List Payment Terms',
	// 		// 	path: 'paymentTerms',
	// 		// 	icon: 'ViewDay',
	// 		// },
	// 		createPaymentTerms: {
	// 			id: 'createPaymentTerms',
	// 			text: 'Create Payment Terms',
	// 			path: 'paymentTerms/create',
	// 			icon: 'add',
	// 			hide: false,
	// 		},
	// 		editPaymentTerms: {
	// 			id: 'editPaymentTerms',
	// 			text: 'Edit Payment Terms',
	// 			path: 'paymentTerms/edit/:id',
	// 			icon: 'edit',
	// 			hide: true,
	// 		},
	// 		detailPaymentTerms: {
	// 			id: 'detailPaymentTerms',
	// 			text: 'Detail Payment Terms',
	// 			path: 'paymentTerms/detail/:id',
	// 			icon: 'add',
	// 			hide: true,
	// 		},
	// 	},
	// 	hide: false,
	// },

	verificationProcessPage: {
		id: 'verification_process',
		text: 'Verification Process',
		path: 'verification_process',
		icon: 'Verified',
		// notification: true,
		subMenu: {
			requisition: {
				id: 'requisition',
				text: 'Requisition',
				path: 'verification_process/requisition',
				icon: 'Settings',
			},
			purchase_indent: {
				id: 'purchase_indent',
				text: 'Purchase Indent',
				path: 'verification_process/purchase_indent',
				icon: 'ShoppingBasket',
			},
			purchase_order: {
				id: 'purchase_order',
				text: 'Purchase Order',
				path: 'verification_process/purchase_order',
				icon: 'Storefront',
			},
			purchase_bill: {
				id: 'purchase_bill',
				text: 'Purchase Bill',
				path: 'verification_process/purchase_bill',
				icon: 'ShoppingBag',
			},
			cheque_signature: {
				id: 'cheque_signature',
				text: 'Cheque Signature',
				path: 'verification_process/cheque_signature',
				icon: 'Draw',
			},
		},
	},

	placeOfSupplyPage: {
		id: 'place_of_supply',
		text: 'Place Of Supply',
		path: 'placeOfSupply',
		icon: 'EmojiTransportation',
		subMenu: {
			// listPlaceOfSupply: {
			// 	id: 'listPlaceOfSupply',
			// 	text: 'List Place Of Supply',
			// 	path: 'placeOfSupply',
			// 	icon: 'ViewDay',
			// },
			createPlaceOfSupply: {
				id: 'createPlaceOfSupply',
				parentModule: 'place_of_supply',
				text: 'Create Place Of Supply',
				path: 'placeOfSupply/create',
				icon: 'add',
			},
			editPlaceOfSupply: {
				id: 'updatePlaceOfSupply',
				parentModule: 'place_of_supply',
				text: 'Update Place Of Supply',
				path: 'placeOfSupply/update/:id',
				icon: 'edit',
				hide: true,
			},
		},
	},

	staffPage: {
		id: 'staff',
		text: 'Staff',
		path: 'staff',
		icon: 'People',
		// notification: true,
		subMenu: {
			// listStaff: {
			// 	id: 'listStaff',
			// 	text: 'List Staff',
			// 	path: 'staff',
			// 	icon: 'ViewDay',
			// },
			createStaff: {
				id: 'createStaff',
				parentModule: 'staff',
				text: 'Create Staff',
				path: 'staff/create',
				icon: 'add',
			},
			editStaff: {
				id: 'updateStaff',
				parentModule: 'staff',
				text: 'Update Staff',
				path: 'staff/update/:id',
				icon: 'edit',
				hide: true,
			},
			detailStaff: {
				id: 'detailStaff',
				parentModule: 'staff',
				text: 'Detail Staff',
				path: 'staff/detail/:id',
				icon: 'add',
				hide: true,
			},
		},
	},

	areaPage: {
		id: 'area',
		text: 'Area',
		path: 'area',
		icon: 'LocationOn',
		// notification: true,
		// subMenu: null,
		subMenu: {
			// listArea: {
			// 	id: 'listArea',
			// 	text: 'List Area',
			// 	path: 'area',
			// 	icon: 'ViewList',
			// },
			createArea: {
				id: 'createArea',
				parentModule: 'area',
				text: 'Create Area',
				path: 'area/create',
				icon: 'add',
			},
			updateArea: {
				id: 'updateArea',
				parentModule: 'area',
				text: 'Update Area',
				path: 'area/update/:id',
				hide: true,
			},
		},
	},

	siteVerificationChecklistPage: {
		id: 'qc_site_verification',
		text: 'QC (Site Verification)',
		path: 'siteVerification',
		icon: 'Checklist',
		subMenu: {
			siteVerificationChecklistPage: {
				id: 'site_verification_checklist',
				text: 'Checklist',
				path: 'siteVerificationChecklist',
				icon: 'TaskAlt',
				subMenu: {
					createSiteVerificationChecklist: {
						id: 'createSiteVerificationChecklist',
						parentModule: 'site_verification_checklist',
						text: 'Create Site Verification Checklist',
						path: 'siteVerificationChecklist/create',
						icon: 'add',
					},
					updateSiteVerificationChecklist: {
						id: 'updateSiteVerificationChecklist',
						parentModule: 'site_verification_checklist',
						text: 'Update Site Verification Checklist',
						path: 'siteVerificationChecklist/update/:id',
						hide: true,
					},
				},
			},
			siteVerificationPage: {
				id: 'site_verification',
				text: 'Site Verification ',
				path: 'siteVerification',
				icon: 'MapsHomeWork',
				subMenu: {
					createSiteVerification: {
						id: 'createSiteVerification',
						parentModule: 'site_verification',
						text: 'Create Site Verification ',
						path: 'siteVerification/create',
						icon: 'add',
					},
					updateSiteVerification: {
						id: 'updateSiteVerification',
						parentModule: 'site_verification',
						text: 'Update Site Verification ',
						path: 'siteVerification/update/:id',
						hide: true,
					},
					detailSiteVerification: {
						id: 'detailSiteVerification',
						parentModule: 'site_verification',
						text: 'Site Verification Detail',
						path: 'siteVerification/detail/:id',
						icon: 'info',
						hide: true,
					},
				},
			},
		},
	},

	// AI reports - AI Integration page
	aiReportPage: {
		id: 'aiReportPage',
		text: 'AI Reports',
		path: 'aiReports',
		icon: 'SmartToy',
		subMenu: {
			productReportPage: {
				id: 'productReport',
				parentModule: 'aiReportPage',
				text: 'Product Report',
				path: 'aiReports/productReport',
				icon: 'Insights',
				subMenu: null,
			},
			siteWiseSupplierPaymentInfoReportPage: {
				id: 'siteWiseSupplierPaymentInfoReport',
				parentModule: 'aiReportPage',
				text: 'Site Wise Supplier Payment',
				path: 'aiReports/siteWiseSupplierPaymentInfoReport',
				icon: 'Insights',
				subMenu: null,
			},
			getProductPurchaseAnalyticsReportPage: {
				id: 'getProductPurchaseAnalyticsReport',
				parentModule: 'aiReportPage',
				text: 'Product Purchase Analytics',
				path: 'aiReports/getProductPurchaseAnalytics',
				icon: 'QueryStats',
				subMenu: null,
			},
		},
	},

	// HRM
	hrmPage: {
		id: 'hrmPage',
		text: 'HRM',
		parentModule: 'hrm',
		path: 'hrmPage',
		icon: 'Badge',
		subMenu: {
			holidayManagement: {
				id: 'hrm',
				text: 'Holiday Management',
				path: 'hrm/holidays',
				icon: 'BeachAccess',
				subMenu: {
					createHoliday: {
						id: 'createHoliday',
						parentModule: 'hrm',
						text: 'Create Holiday',
						path: 'hrm/holidays/create',
						icon: 'add',
					},
					editHoliday: {
						id: 'editHoliday',
						text: 'Edit Holiday',
						parentModule: 'hrm',
						path: 'hrm/holidays/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailHoliday: {
						id: 'detailHoliday',
						parentModule: 'hrm',
						text: 'Holiday Detail',
						path: 'hrm/holidays/detail/:id',
						icon: 'info',
						hide: true,
					},
				},
			},
			attendance: {
				id: 'attendance',
				text: 'Attendance',
				path: 'hrm/attendance',
				icon: 'HowToReg',
				subMenu: {
					calendar: {
						id: 'calendar',
						parentModule: 'attendance',
						text: 'Calendar',
						path: 'hrm/attendance/calendar',
						icon: 'CalendarToday',
					},
					attendanceMonthlyReport: {
						id: 'attendanceMonthlyReport',
						parentModule: 'attendance',
						text: 'Monthly Report',
						path: 'hrm/attendance/attendanceMonthlyReport',
						icon: 'CalendarViewMonth',
						subMenu: {
							attendanceMonthlyReportDetail: {
								id: 'attendanceMonthlyReportDetail',
								parentModule: 'attendanceMonthlyReport',
								text: 'Monthly Report Detail',
								path: 'hrm/attendance/attendanceMonthlyReport/detail',
								hide: true,
							},
						},
					},
					detailAttendance: {
						id: 'detailAttendance',
						parentModule: 'attendance',
						text: 'Detail Attendance',
						path: 'hrm/attendance/detail/:id',
						hide: true,
					},
					requestManagement: {
						id: 'requestManagement',
						parentModule: 'attendance',
						text: 'Request Management',
						path: 'hrm/attendance/requestManagement',
						icon: 'SupervisedUserCircle',
						subMenu: {
							createRequestManagement: {
								id: 'createRequestManagement',
								parentModule: 'attendance',
								text: 'Create Request',
								path: 'hrm/attendance/requestManagement/create',
								icon: 'Add',
							},
							editRequestManagement: {
								id: 'editRequestManagement',
								parentModule: 'attendance',
								text: 'Edit Request',
								path: 'hrm/attendance/requestManagement/edit/:id',
								icon: 'Add',
								hide: true,
							},
							detailRequestManagement: {
								id: 'detailRequestManagement',
								parentModule: 'attendance',
								text: 'Detail Request',
								path: 'hrm/attendance/requestManagement/detail/:id',
								icon: 'Add',
								hide: true,
							},
						},
					},
					staffPaySlipAndAttendance: {
						id: 'staffPaySlipAndAttendance',
						parentModule: 'attendance',
						text: 'Staff Salary Slip',
						path: 'hrm/attendance/staffPaySlipAndAttendance',
						icon: 'Paid',
						subMenu: {
							detailStaffPaySlipAndAttendance: {
								id: 'staffPaySlipAndAttendance',
								parentModule: 'attendance',
								text: 'Detail Staff PaySlip & Attendance',
								path: 'hrm/attendance/staffPaySlipAndAttendance/detail/:id',
								icon: 'Paid',
								hide: true,
							},
						},
					},
				},
			},
			salaryManagement: {
				id: 'salary_management',
				text: 'Salary Management',
				path: 'hrm/staffSalary',
				icon: 'Payments',
				subMenu: {
					createStaffSalary: {
						id: 'createStaffSalary',
						parentModule: 'salary_management',
						text: 'Create StaffSalary',
						path: 'hrm/staffSalary/create',
						icon: 'add',
					},
					updateStaffSalary: {
						id: 'updateStaffSalary',
						parentModule: 'salary_management',
						text: 'Update StaffSalary',
						path: 'hrm/staffSalary/update/:id',
						hide: true,
					},
					detailStaffSalary: {
						id: 'detailStaffSalary',
						parentModule: 'salary_management',
						text: 'Detail Staff Salary',
						path: 'hrm/staffSalary/detail/:id',
						hide: true,
					},
				},
			},
			salaryStructureManagement: {
				id: 'salaryStructureManagement',
				text: 'Salary Structure Management',
				path: 'hrm/staffSalaryStructure',
				icon: 'Payments',
				subMenu: {
					createStaffSalaryStructure: {
						id: 'createStaffSalary',
						parentModule: 'salaryStructureManagement',
						text: 'Create Staff Salary Structure',
						path: 'hrm/staffSalaryStructure/create',
						icon: 'add',
					},
					updateStaffSalaryStructure: {
						id: 'updateStaffSalaryStructure',
						parentModule: 'salaryStructureManagement',
						text: 'Update Staff Salary Structure',
						path: 'hrm/staffSalaryStructure/update/:id',
						hide: true,
					},
					detailStaffSalaryStructure: {
						id: 'detailStaffSalary',
						parentModule: 'salaryStructureManagement',
						text: 'Detail Staff Salary Structure',
						path: 'hrm/staffSalaryStructure/detail/:id',
						hide: true,
					},
				},
			},
			allowanceManagement: {
				id: 'allowance_management',
				// parentModule: 'hrm',
				text: 'Allowance Management',
				path: 'hrm/allowance',
				icon: 'CardGiftcard',
				subMenu: {
					createStaffAllowance: {
						id: 'createStaffAllowance',
						parentModule: 'hrm',
						text: 'Create StaffAllowance',
						path: 'hrm/allowance/create',
						icon: 'add',
					},
					updateStaffAllowance: {
						id: 'updateStaffAllowance',
						parentModule: 'hrm',
						text: 'Update StaffAllowance',
						path: 'hrm/allowance/edit/:id',
						hide: true,
					},
					detailStaffAllowance: {
						id: 'detailStaffAllowance',
						parentModule: 'hrm',
						text: 'Detail StaffAllowance',
						path: 'hrm/allowance/detail/:id',
						hide: true,
					},
				},
			},
			celebrationManagement: {
				id: 'celebration_management',
				parentModule: 'hrm',
				text: 'Celebration Management',
				path: 'hrm/celebration',
				icon: 'Cake',
				subMenu: {
					createStaffCelebration: {
						id: 'createStaffCelebration',
						parentModule: 'hrm',
						text: 'Create Celebration',
						path: 'hrm/celebration/create',
						icon: 'add',
					},
					updateStaffCelebration: {
						id: 'updateStaffCelebration',
						parentModule: 'hrm',
						text: 'Update Celebration',
						path: 'hrm/celebration/edit/:id',
						hide: true,
					},
					detailStaffCelebration: {
						id: 'detailStaffCelebration',
						parentModule: 'hrm',
						text: 'Detail Celebration',
						path: 'hrm/celebration/detail/:id',
						hide: true,
					},
				},
			},
			devicePage: {
				id: 'cams',
				text: 'Device',
				path: 'hrm/device',
				icon: 'Biotech',
				subMenu: {
					createDevice: {
						id: 'createDevice',
						parentModule: 'cams',
						text: 'Create Device',
						path: 'hrm/device/create',
						icon: 'add',
					},
					updateDevice: {
						id: 'updateDevice',
						parentModule: 'cams',
						text: 'Update Device',
						path: 'hrm/device/update/:id',
						hide: true,
					},
					detailDevice: {
						id: 'detailDevice',
						parentModule: 'cams',
						text: 'Device Detail',
						path: 'hrm/device/detail/:id',
						hide: true,
					},
				},
			},
			deviceUserPage: {
				id: 'cams',
				text: 'Device User',
				path: 'hrm/deviceUser',
				icon: 'ConnectWithoutContact',
				// notification: true,
				// subMenu: null,
				subMenu: {
					createDeviceUser: {
						id: 'createDeviceUser',
						parentModule: 'cams',
						text: 'Create Device User',
						path: 'hrm/deviceUser/create',
						icon: 'add',
					},
					updateDeviceUser: {
						id: 'updateDeviceUser',
						parentModule: 'cams',
						text: 'Update Device User',
						path: 'hrm/deviceUser/update/:id',
						hide: true,
					},
				},
			},
			staffPunchDataPage: {
				id: 'staffPunchData',
				parentModule: 'staff_attendance_report',
				text: 'Staff Punch Data',
				path: 'hrm/staffPunch',
				icon: 'Fingerprint',
				// notification: true,
				subMenu: null,
			},
			manageAttendancePage: {
				id: 'staff_attendance_report',
				parentModule: 'hrm',
				text: 'Manage Attendance',
				path: 'hrm/manageAttendance',
				icon: 'EventAvailable',
				subMenu: null,
			},
			shiftManagement: {
				id: 'shiftManagement',
				text: 'Shift Management',
				path: 'hrm/shiftManagement',
				icon: 'AccessTimeFilled',
				subMenu: {
					createShift: {
						id: 'createShift',
						parentModule: 'shiftManagement',
						text: 'Create Shift',
						path: 'hrm/shiftManagement/create',
						icon: 'add',
					},
					editShift: {
						id: 'editShift',
						parentModule: 'shiftManagement',
						text: 'Edit Shift',
						path: 'hrm/shiftManagement/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailShift: {
						id: 'detailShift',
						parentModule: 'shiftManagement',
						text: 'Shift Detail',
						path: 'hrm/shiftManagement/detail/:id',
						icon: 'info',
						hide: true,
					},
				},
			},
		},
	},

	// Inventory Management
	inventoryManagementPage: {
		id: 'inventory_management',
		text: 'Inventory Management',
		path: 'inventoryManagement',
		icon: 'Inventory',
		subMenu: {
			liveProductStockPage: {
				id: 'liveProductStock',
				parentModule: 'inventory_management',
				text: 'Product Live Stock',
				path: 'inventoryManagement/liveProductStock',
				icon: 'Insights',
				subMenu: null,
			},
			masterStockPage: {
				id: 'stock_master',
				parentModule: 'inventory_management',
				text: 'Master Stock',
				path: 'inventoryManagement/masterStock',
				icon: 'Inventory2',
				subMenu: {
					createMasterStockPage: {
						id: 'createMasterStockPage',
						parentModule: 'inventory_management',
						text: 'Create Master Stock',
						path: 'inventoryManagement/masterStock/create',
						icon: 'add',
					},
					updateMasterStockPage: {
						id: 'updateMasterStockPage',
						parentModule: 'inventory_management',
						text: 'Update Master Stock',
						path: 'inventoryManagement/masterStock/update/:id',
						icon: 'Tune',
						hide: true,
					},
					detailStockAdjustmentPage: {
						id: 'detailMasterStockPage',
						parentModule: 'inventory_management',
						text: 'Detail Master Stock',
						path: 'inventoryManagement/masterStock/detail/:id',
						icon: 'Tune',
						hide: true,
					},
				},
			},
			stockAdjustmentPage: {
				id: 'stock_adjustment',
				parentModule: 'inventory_management',
				text: 'Stock Adjustment',
				path: 'inventoryManagement/stockAdjustment',
				icon: 'Tune',
				subMenu: {
					createStockAdjustmentPage: {
						id: 'createStockAdjustmentPage',
						parentModule: 'inventory_management',
						text: 'Create Stock Adjustment',
						path: 'inventoryManagement/stockAdjustment/create',
						icon: 'add',
					},
					editStockAdjustmentPage: {
						id: 'editStockAdjustmentPage',
						parentModule: 'inventory_management',
						text: 'Edit Stock Adjustment',
						path: 'inventoryManagement/stockAdjustment/edit/:id',
						icon: 'add',
						hide: true,
					},
					detailStockAdjustmentPage: {
						id: 'detailStockAdjustmentPage',
						parentModule: 'inventory_management',
						text: 'Detail Stock Adjustment',
						path: 'inventoryManagement/stockAdjustment/detail/:id',
						icon: 'Tune',
						hide: true,
					},
				},
			},
			stockTransferPage: {
				id: 'stock_transfer',
				parentModule: 'inventory_management',
				text: 'Stock Transfer',
				path: 'inventoryManagement/stockTransfer',
				icon: 'SwapHoriz',
				subMenu: {
					createStockTransfer: {
						id: 'createStockTransfer',
						parentModule: 'inventory_management',
						text: 'Create Stock Transfer',
						path: 'inventoryManagement/stockTransfer/create',
						icon: 'add',
					},
					editStockTransfer: {
						id: 'editStockTransfer',
						parentModule: 'inventory_management',
						text: 'Edit Stock Transfer',
						path: 'inventoryManagement/stockTransfer/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailStockTransfer: {
						id: 'detailStockTransfer',
						parentModule: 'inventory_management',
						text: 'Detail Stock Transfer',
						path: 'inventoryManagement/stockTransfer/detail/:id',
						icon: 'info',
						hide: true,
					},
				},
			},
		},
	},

	// Resource Management
	resourceInventoryPage: {
		id: 'resource_management',
		text: 'Resource Management',
		path: 'resourceInventory',
		icon: 'Storage',
		subMenu: {
			warehouse: {
				id: 'warehouse',
				text: 'Warehouse',
				path: 'resourceInventory/warehouse',
				icon: 'Store',
				subMenu: {
					createWarehouse: {
						id: 'createWarehouse',
						parentModule: 'warehouse',
						text: 'Create Warehouse',
						path: 'resourceInventory/warehouse/create',
						icon: 'add',
					},
					editWarehouse: {
						id: 'editWarehouse',
						parentModule: 'warehouse',
						text: 'Edit Warehouse',
						path: 'resourceInventory/warehouse/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailWarehouse: {
						id: 'detailWarehouse',
						parentModule: 'warehouse',
						text: 'Warehouse Detail',
						path: 'resourceInventory/warehouse/detail/:id',
						icon: 'info',
						hide: true,
					},
				},
			},
			resources: {
				id: 'resources',
				text: 'Resources',
				path: 'resourceInventory/resources',
				icon: 'BuildCircle',
				subMenu: {
					createResource: {
						id: 'createResource',
						parentModule: 'resources',
						text: 'Create Resource',
						path: 'resourceInventory/resources/create',
						icon: 'add',
					},
					editResource: {
						id: 'editResource',
						parentModule: 'resources',
						text: 'Edit Resource',
						path: 'resourceInventory/resources/edit/:id',
						icon: 'edit',
						hide: true,
					},
					detailResource: {
						id: 'detailResource',
						parentModule: 'resources',
						text: 'Resource Detail',
						path: 'resourceInventory/resources/detail/:id',
						icon: 'info',
						hide: true,
					},
				},
			},
			liveResourcesByCompanyWarehouse: {
				id: 'liveResourcesByCompanyWarehouse',
				text: 'Live Resources By Company Warehouse',
				path: 'resourceInventory/liveResourcesByCompanyWarehouse',
				icon: 'Sensors',
				subMenu: null,
			},
			resourceAllocation: {
				id: 'resourceAllocation',
				text: 'Resource Allocation',
				path: 'resourceInventory/resourceAllocation',
				icon: 'AccountTree',
				subMenu: {
					createResource: {
						id: 'createResourceAllocation',
						parentModule: 'resourceAllocation',
						text: 'Allocate Resource',
						path: 'resourceInventory/resourceAllocation/create',
						icon: 'add',
					},
					editResource: {
						id: 'editResourceAllocation',
						parentModule: 'resourceAllocation',
						text: 'Edit Allocate Resource',
						path: 'resourceInventory/resourceAllocation/edit/:id',
						icon: 'edit',
						hide: true,
					},
					verifyResource: {
						id: 'verifyResourceAllocation',
						parentModule: 'resourceAllocation',
						text: 'Verify Resource',
						path: 'resourceInventory/resourceAllocation/verifyResource/:id',
						icon: 'info',
						hide: true,
					},
				},
			},
		},
	},

	// Notification Config Pgae
	notificationConfigPage: {
		id: 'notificationConfig',
		text: 'Notification Config',
		path: 'notificationConfig',
		icon: 'Notifications',
		subMenu: {
			createNotificationConfig: {
				id: 'createNotificationConfig',
				text: 'Create Notification Config',
				path: 'notificationConfig/create',
				icon: 'add',
			},
			updateNotificationConfig: {
				id: 'updateNotificationConfig',
				text: 'Update Notification Config',
				path: 'notificationConfig/update/:id',
				hide: true,
			},
		},
	},

	// Notification Pgae
	notificationPage: {
		id: 'notification',
		text: 'Notifications',
		path: 'notifications',
		icon: 'NotificationsActive',
		subMenu: {
			createNotification: {
				id: 'createNotification',
				text: 'Create Notification',
				path: 'notifications/create',
				icon: 'add',
			},
			updateNotification: {
				id: 'updateNotification',
				text: 'Update Notification',
				path: 'notifications/update/:id',
				hide: true,
			},
			detailNotification: {
				id: 'detailNotification',
				text: 'Detail Notification',
				path: 'notifications/detail/:id',
				hide: true,
			},
		},
	},

	siteManagementPage: {
		id: 'site_management',
		text: 'Booking Management',
		path: 'siteManagement',
		icon: 'Web',
		subMenu: {
			createSiteManagement: {
				id: 'createSiteManagement',
				parentModule: 'site_management',
				text: 'Create Site Booking',
				path: 'siteManagement/create',
				icon: 'add',
			},
			siteManagementSummary: {
				id: 'siteManagementSummary',
				parentModule: 'site_management',
				text: 'Booking Summary',
				path: 'siteManagement/summary',
				icon: 'Summarize',
			},
			updateSiteManagement: {
				id: 'updateSiteManagement',
				parentModule: 'site_management',
				text: 'Update Site Booking',
				path: 'siteManagement/update/:id',
				hide: true,
			},

			detailSiteManagement: {
				id: 'detailSiteManagement',
				parentModule: 'site_management',
				text: 'Booking Detail',
				path: 'siteManagement/detail/:id',
				icon: 'info',
				hide: true,
			},
		},
	},
	// Notification Config Pgae
	contractManagementPage: {
		id: 'contract_management',
		text: 'Contract Management',
		path: 'contractManagement',
		icon: 'Description',
		subMenu: {
			createContractManagement: {
				id: 'createContractManagement',
				parentModule: 'contract_management',
				text: 'Create Contract Management',
				path: 'contractManagement/create',
				icon: 'add',
			},
			updateContractManagement: {
				id: 'updateContractManagement',
				parentModule: 'contract_management',
				text: 'Update Contract Management',
				path: 'contractManagement/update/:id',
				hide: true,
			},
			detailContractManagement: {
				id: 'detailContractManagement',
				parentModule: 'contract_management',
				text: 'Contract Management Detail',
				path: 'contractManagement/detail/:id',
				icon: 'info',
				hide: true,
			},
			expiringAMCManagement: {
				id: 'expiringAMCManagement',
				parentModule: 'contract_management',
				text: 'AMC Expiring',
				path: 'contractManagement/expiringAMC',
				icon: 'HourglassTop',
			},
			expiredAMCManagement: {
				id: 'expiredAMCManagement',
				parentModule: 'contract_management',
				text: 'AMC Expired',
				path: 'contractManagement/expiredAMC',
				icon: 'HourglassBottom',
			},
		},
	},
	// NOC page
	nocManagementPage: {
		id: 'noc',
		text: 'NOC Management',
		path: 'nocManagement',
		icon: 'CarRepair',
		subMenu: {
			createNocManagement: {
				id: 'createNocManagement',
				parentModule: 'noc',
				text: 'Create NOC Management',
				path: 'nocManagement/create',
				icon: 'add',
			},
			updateNocManagement: {
				id: 'updateNocManagement',
				parentModule: 'noc',
				text: 'Update NOC Management',
				path: 'nocManagement/update/:id',
				hide: true,
			},
			detailNocManagement: {
				id: 'detailNocManagement',
				parentModule: 'noc',
				text: 'NOC Management Detail',
				path: 'nocManagement/detail/:id',
				icon: 'info',
				hide: true,
			},
			expiringNocManagement: {
				id: 'expiringNocManagement',
				parentModule: 'noc',
				text: 'NOC Expiring',
				path: 'nocManagement/expiringNoc',
				icon: 'HourglassTop',
			},
			expiredNocManagement: {
				id: 'expiredNocManagement',
				parentModule: 'noc',
				text: 'NOC Expired',
				path: 'nocManagement/expiredNoc',
				icon: 'HourglassBottom',
			},
		},
	},
	// Vehicle page
	vehicleManagementPage: {
		id: 'vehicle_management',
		text: 'Vehicle Management',
		path: 'vehicleManagement',
		icon: 'LocalShipping',
		subMenu: {
			createVehicleManagement: {
				id: 'createVehicleManagement',
				parentModule: 'vehicle_management',
				text: 'Create Vehicle Management',
				path: 'vehicleManagement/create',
				icon: 'add',
			},
			updateVehicleManagement: {
				id: 'updateVehicleManagement',
				parentModule: 'vehicle_management',
				text: 'Update Vehicle Management',
				path: 'vehicleManagement/update/:id',
				hide: true,
			},
			detailVehicleManagement: {
				id: 'detailVehicleManagement',
				parentModule: 'vehicle_management',
				text: 'Vehicle Management Detail',
				path: 'vehicleManagement/detail/:id',
				icon: 'info',
				hide: true,
			},
			expiringVehicleManagement: {
				id: 'expiringVehicleManagement',
				parentModule: 'vehicle_management',
				text: 'Documents Expiring',
				path: 'vehicleManagement/expiringVehicle',
				icon: 'HourglassTop',
			},
			expiredVehicleManagement: {
				id: 'expiredVehicleManagement',
				parentModule: 'vehicle_management',
				text: 'Documents Expired',
				path: 'vehicleManagement/expiredVehicle',
				icon: 'HourglassBottom',
			},
		},
	},
	// CRM - Inquiry page
	inquiryManagementPage: {
		id: 'inquiry_management',
		text: 'CRM - Inquiry Management',
		path: 'inquiryManagement',
		icon: 'ContactSupport',
		subMenu: {
			createInquiryManagement: {
				id: 'createInquiryManagement',
				parentModule: 'inquiry_management',
				text: 'Create Inquiry Management',
				path: 'inquiryManagement/create',
				icon: 'add',
			},
			updateInquiryManagement: {
				id: 'updateInquiryManagement',
				parentModule: 'inquiry_management',
				text: 'Update Inquiry Management',
				path: 'inquiryManagement/update/:id',
				hide: true,
			},
			detailInquiryManagement: {
				id: 'detailInquiryManagement',
				parentModule: 'inquiry_management',
				text: 'Inquiry Management Detail',
				path: 'inquiryManagement/detail/:id',
				icon: 'info',
				hide: true,
			},
		},
	},

	// Day Book page
	dayBookPage: {
		id: 'day_book',
		text: 'Day Book',
		path: 'dayBook',
		icon: 'Book',
		subMenu: {
			createDayBook: {
				id: 'createDayBook',
				parentModule: 'day_book',
				text: 'Create Day Book',
				path: 'dayBook/create',
				icon: 'add',
			},
			updateDayBook: {
				id: 'updateDayBook',
				parentModule: 'day_book',
				text: 'Update Day Book',
				path: 'dayBook/update/:id',
				hide: true,
			},
			detailDayBook: {
				id: 'detailDayBook',
				parentModule: 'day_book',
				text: 'Day Book Detail',
				path: 'dayBook/detail/:id',
				icon: 'info',
				hide: true,
			},
		},
	},

	expensesAndBillsPage: {
		id: 'expenses_and_bills',
		text: 'Expenses & Bills',
		path: 'expenses',
		icon: 'RequestQuote',
		subMenu: {
			createExpenses: {
				id: 'createExpenses',
				parentModule: 'expenses_and_bills',
				text: 'Create Expense',
				path: 'expenses/create',
				icon: 'add',
			},
			updateExpenses: {
				id: 'updateExpenses',
				parentModule: 'expenses_and_bills',
				text: 'Update Expense',
				path: 'expenses/update/:id',
				hide: true,
			},
			detailExpenses: {
				id: 'detailExpenses',
				parentModule: 'expenses_and_bills',
				text: 'Expense Detail',
				path: 'expenses/detail/:id',
				icon: 'info',
				hide: true,
			},
		},
	},

	roleAndPermissionPage: {
		id: 'settings',
		text: 'Role & Permission',
		path: 'roleAndPermission',
		icon: 'Security',
		subMenu: {
			role: {
				id: 'role',
				parentModule: 'settings',
				text: 'Role',
				path: 'roleAndPermission/role',
				icon: 'PersonOutline',
			},
			permission: {
				id: 'permission',
				parentModule: 'settings',
				text: 'Permission',
				path: 'roleAndPermission/permission',
				icon: 'AdminPanelSettings',
			},
			permissionAllocation: {
				id: 'permissionAllocation',
				parentModule: 'settings',
				text: 'Permission Allocation',
				path: 'roleAndPermission/permissionAllocation',
				icon: 'Rule',
			},
		},
	},



	// reportsPage: {
	// 	id: 'reports',
	// 	text: 'Reports',
	// 	path: 'reports',
	// 	icon: 'AutoStories',
	// 	// notification: true,
	// 	subMenu: null,
	// },
	updateProfilePage: {
		id: 'updateProfile',
		text: 'Profile',
		path: '/profile/update',
		icon: 'AutoStories',
		// notification: true,
		subMenu: null,
		hide: true,
	},
	updateCompanyProfilePage: {
		id: 'updateCompanyProfile',
		text: 'Company Profile',
		path: '/company-profile/update',
		icon: 'AutoStories',
		// notification: true,
		subMenu: null,
		hide: true,
	},
};

export const settingPageMenu = {
	pages: {
		id: 'setting',
		text: 'Setting',
		icon: 'Extension',
	},
	settingsPage: {
		id: 'staff',
		text: 'Staff',
		path: 'staff',
		icon: 'AutoStories',
		// notification: true,
		subMenu: {
			listRole: {
				id: 'listRole',
				text: 'Role',
				path: 'role',
				icon: 'ViewList',
			},
			createRole: {
				id: 'createRole',
				text: 'Create Role',
				path: 'role/create',
				icon: 'add',
			},
		},
	},
};

export const productPagesMenu = {
	pages: {
		id: 'product',
		text: 'Product',
		icon: 'Extension',
	},
	productPages: {
		id: 'productPages',
		text: 'Products',
		path: 'product',
		icon: 'Dvr',
		subMenu: {
			cretaeProduct: {
				id: 'cretaeProduct',
				text: 'Create Product',
				path: 'product/create-product',
				icon: 'ViewArray',
			},
			listProduct: {
				id: 'listProduct',
				text: 'List Product',
				path: 'product/list-product',
				icon: 'ViewDay',
			},
		},
	},
};
export const categoryPagesMenu = {
	pages: {
		id: 'category',
		text: 'Category',
		icon: 'Extension',
	},
	categoryPages: {
		id: 'categoryPages',
		text: 'Category',
		path: 'category',
		icon: 'Dvr',
		subMenu: {
			cretaeCategory: {
				id: 'cretaeCategory',
				text: 'Create Category',
				path: 'category/create-category',
				icon: 'ViewArray',
			},
			listCategory: {
				id: 'listCategory',
				text: 'List Category',
				path: 'category/list-category',
				icon: 'ViewDay',
			},
		},
	},
};

export const hrmPagesMenu = {
	pages: {
		id: 'hrm',
		text: 'HRM',
		icon: 'Extension',
	},
	hrmPages: {
		id: 'productPages',
		text: 'HRM',
		path: 'product',
		icon: 'Dvr',
		subMenu: {
			cretaeProduct: {
				id: 'cretaeProduct',
				text: 'Create Product',
				path: 'product/create-product',
				icon: 'ViewArray',
			},
			listProduct: {
				id: 'listProduct',
				text: 'List Product',
				path: 'product/list-product',
				icon: 'ViewDay',
			},
		},
	},
};
export const qcPagesMenu = {
	pages: {
		id: 'qc',
		text: 'QC',
		icon: 'Extension',
	},
	qcPages: {
		id: 'productPages',
		text: 'QC',
		path: 'product',
		icon: 'Dvr',
		subMenu: {
			cretaeProduct: {
				id: 'cretaeProduct',
				text: 'Create Product',
				path: 'product/create-product',
				icon: 'ViewArray',
			},
			listProduct: {
				id: 'listProduct',
				text: 'List Product',
				path: 'product/list-product',
				icon: 'ViewDay',
			},
		},
	},
};
export const crmPagesMenu = {
	pages: {
		id: 'crm',
		text: 'CRM',
		icon: 'Extension',
	},
	crmPages: {
		id: 'productPages',
		text: 'CRM',
		path: 'product',
		icon: 'Dvr',
		subMenu: {
			cretaeProduct: {
				id: 'cretaeProduct',
				text: 'Create Product',
				path: 'product/create-product',
				icon: 'ViewArray',
			},
			listProduct: {
				id: 'listProduct',
				text: 'List Product',
				path: 'product/list-product',
				icon: 'ViewDay',
			},
		},
	},
};

export const demoPagesMenu = {
	pages: {
		id: 'pages',
		text: 'Pages',
		icon: 'Extension',
	},
	sales: {
		id: 'sales',
		text: 'Sales',
		path: 'sales',
		icon: 'Store',
		subMenu: {
			dashboard: dashboardPagesMenu.dashboard,
			salesList: {
				id: 'products',
				text: 'Sales List',
				path: 'sales/sales-list',
				icon: 'FactCheck',
			},
			productsGrid: {
				id: 'productsGrid',
				text: 'Products Grid',
				path: 'sales/grid',
				icon: 'CalendarViewMonth',
			},
			productID: {
				id: 'productID',
				text: 'productID',
				path: 'sales/product',
				hide: true,
			},
			product: {
				id: 'product',
				text: 'Product',
				path: 'sales/product/1',
				icon: 'QrCode2',
			},
			transactions: {
				id: 'transactions',
				text: 'Transactions',
				path: 'sales/transactions',
				icon: 'PublishedWithChanges',
			},
		},
	},

	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	login: {
		id: 'login',
		text: 'Login',
		path: 'auth-pages/login',
		icon: 'Login',
	},
	changePassword: {
		id: 'changePassword',
		text: 'Change Password',
		path: 'change-password',
		icon: 'Login',
	},
	resetPassword: {
		id: 'resetPassword',
		text: 'Reset Password',
		path: 'reset-password',
		icon: 'Refresh',
	},
	forgotPassword: {
		id: 'forgotPassword',
		text: 'Forgot Password',
		path: 'auth-pages/forgot-password',
		icon: 'Login',
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
	},
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
	},
	privacyPolicy: {
		id: 'privacyPolicy',
		text: 'Privacy Policy',
		path: 'privacy-policy',
		icon: 'ReportGmailerrorred',
	},
	termsAndCondition: {
		id: 'termsAndCondition',
		text: 'Terms & Condition',
		path: 'terms-and-condition',
		icon: 'ReportGmailerrorred',
	},
	deleteDataPage: {
		id: 'deleteData',
		text: 'Delete Data',
		path: 'deleteData',
		icon: 'Delete',
		subMenu: null,
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: 'layoutTypes',
		text: 'Page Layout Types',
	},
	blank: {
		id: 'blank',
		text: 'Blank',
		path: 'page-layouts/blank',
		icon: 'check_box_outline_blank ',
	},
	pageLayout: {
		id: 'pageLayout',
		text: 'Page Layout',
		path: 'page-layouts',
		icon: 'BackupTable',
		subMenu: {
			headerAndSubheader: {
				id: 'headerAndSubheader',
				text: 'Header & Subheader',
				path: 'page-layouts/header-and-subheader',
				icon: 'ViewAgenda',
			},
			onlyHeader: {
				id: 'onlyHeader',
				text: 'Only Header',
				path: 'page-layouts/only-header',
				icon: 'ViewStream',
			},
			onlySubheader: {
				id: 'onlySubheader',
				text: 'Only Subheader',
				path: 'page-layouts/only-subheader',
				icon: 'ViewStream',
			},
			onlyContent: {
				id: 'onlyContent',
				text: 'Only Content',
				path: 'page-layouts/only-content',
				icon: 'WebAsset',
			},
		},
	},
	asideTypes: {
		id: 'asideTypes',
		text: 'Aside Types',
		path: 'aside-types',
		icon: 'Vertical Split',
		subMenu: {
			defaultAside: {
				id: 'defaultAside',
				text: 'Default Aside',
				path: 'aside-types/default-aside',
				icon: 'ViewQuilt',
			},
			minimizeAside: {
				id: 'minimizeAside',
				text: 'Minimize Aside',
				path: 'aside-types/minimize-aside',
				icon: 'View Compact',
			},
		},
	},
};

export const gettingStartedPagesMenu = {
	gettingStarted: {
		id: 'gettingStarted',
		text: 'Getting Started',
		path: 'getting-started',
		icon: 'Book',
		subMenu: {
			installation: {
				id: 'installation',
				text: 'Installation',
				path: 'getting-started/installation',
				icon: 'BuildCircle',
			},
			dev: {
				id: 'dev',
				text: 'Development',
				path: 'getting-started/development',
				icon: 'DirectionsRun',
			},
			folderStructure: {
				id: 'folderStructure',
				text: 'Folder Structure',
				path: 'getting-started/folder-structure',
				icon: 'SnippetFolder',
			},
			bootstrapVariables: {
				id: 'bootstrapVariables',
				text: 'Bootstrap Variables',
				path: 'getting-started/bootstrap-variables',
				icon: 'SnippetFolder',
			},
			projectStructure: {
				id: 'projectStructure',
				text: 'Project Structure',
				path: 'getting-started/project-structure',
				icon: 'SnippetFolder',
			},
		},
	},
	routes: {
		id: 'routes',
		text: 'Routes & Pages',
		path: 'routes',
		icon: 'AltRoute',
		subMenu: {
			router: {
				id: 'router',
				text: 'Router',
				path: 'routes/router',
				icon: 'Router',
			},
		},
	},
};

export const componentPagesMenu = {
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap',
		icon: 'Extension',
	},
	components: {
		id: 'components',
		text: 'Component',
		path: 'components',
		icon: 'Extension',
		notification: 'success',
		subMenu: {
			accordion: {
				id: 'accordion',
				text: 'Accordion',
				path: 'components/accordion',
				icon: 'ViewDay',
			},
			alert: {
				id: 'alert',
				text: 'Alert',
				path: 'components/alert',
				icon: 'Announcement',
			},
			badge: {
				id: 'badge',
				text: 'Badge',
				path: 'components/badge',
				icon: 'Vibration',
			},
			breadcrumb: {
				id: 'breadcrumb',
				text: 'Breadcrumb',
				path: 'components/breadcrumb',
				icon: 'AddRoad',
			},
			button: {
				id: 'button',
				text: 'Button',
				path: 'components/button',
				icon: 'SmartButton',
			},
			buttonGroup: {
				id: 'buttonGroup',
				text: 'Button Group',
				path: 'components/button-group',
				icon: 'Splitscreen',
			},
			card: {
				id: 'card',
				text: 'Card',
				path: 'components/card',
				icon: 'Crop32',
			},
			carousel: {
				id: 'carousel',
				text: 'Carousel',
				path: 'components/carousel',
				icon: 'RecentActors',
			},
			// Close
			collapse: {
				id: 'collapse',
				text: 'Collapse',
				path: 'components/collapse',
				icon: 'UnfoldLess',
			},
			dropdowns: {
				id: 'dropdowns',
				text: 'Dropdowns',
				path: 'components/dropdowns',
				icon: 'Inventory',
			},
			listGroup: {
				id: 'listGroup',
				text: 'List Group',
				path: 'components/list-group',
				icon: 'ListAlt',
			},
			modal: {
				id: 'modal',
				text: 'Modal',
				path: 'components/modal',
				icon: 'PictureInPicture',
			},
			navsTabs: {
				id: 'navsTabs',
				text: 'Navs & Tabs',
				path: 'components/navs-and-tabs',
				icon: 'PivotTableChart',
			},
			// Navbar
			offcanvas: {
				id: 'offcanvas',
				text: 'Offcanvas',
				path: 'components/offcanvas',
				icon: 'VerticalSplit',
			},
			pagination: {
				id: 'pagination',
				text: 'Pagination',
				path: 'components/pagination',
				icon: 'Money',
			},
			popovers: {
				id: 'popovers',
				text: 'Popovers',
				path: 'components/popovers',
				icon: 'Assistant',
			},
			progress: {
				id: 'progress',
				text: 'Progress',
				path: 'components/progress',
				icon: 'HourglassTop',
			},
			scrollspy: {
				id: 'scrollspy',
				text: 'Scrollspy',
				path: 'components/scrollspy',
				icon: 'KeyboardHide',
			},
			spinners: {
				id: 'spinners',
				text: 'Spinners',
				path: 'components/spinners',
				icon: 'RotateRight',
			},
			table: {
				id: 'table',
				text: 'Table',
				path: 'components/table',
				icon: 'TableChart',
			},
			toasts: {
				id: 'toasts',
				text: 'Toasts',
				path: 'components/toasts',
				icon: 'RotateRight',
			},
			tooltip: {
				id: 'tooltip',
				text: 'Tooltip',
				path: 'components/tooltip',
				icon: 'Assistant',
			},
		},
	},
	forms: {
		id: 'forms',
		text: 'Forms',
		path: 'forms',
		icon: 'CheckBox',
		notification: 'success',
		subMenu: {
			formGroup: {
				id: 'formGroup',
				text: 'Form Group',
				path: 'forms/form-group',
				icon: 'Source',
			},
			formControl: {
				id: 'formControl',
				text: 'Form Controls',
				path: 'forms/form-controls',
				icon: 'Create',
			},
			select: {
				id: 'select',
				text: 'Select',
				path: 'forms/select',
				icon: 'Checklist',
			},
			checksAndRadio: {
				id: 'checksAndRadio',
				text: 'Checks & Radio',
				path: 'forms/checks-and-radio',
				icon: 'CheckBox',
			},
			range: {
				id: 'range',
				text: 'Range',
				path: 'forms/range',
				icon: 'HdrStrong',
			},
			inputGroup: {
				id: 'inputGroup',
				text: 'Input Group',
				path: 'forms/input-group',
				icon: 'PowerInput',
			},
			validation: {
				id: 'validation',
				text: 'Validation',
				path: 'forms/validation',
				icon: 'VerifiedUser',
			},
			wizard: {
				id: 'wizard',
				text: 'Wizard',
				path: 'forms/wizard',
				icon: 'LinearScale',
			},
		},
	},
	content: {
		id: 'content',
		text: 'Content',
		path: 'content',
		icon: 'format_size',
		subMenu: {
			typography: {
				id: 'typography',
				text: 'Typography',
				path: 'content/typography',
				icon: 'text_fields',
			},
			images: {
				id: 'images',
				text: 'Images',
				path: 'content/images',
				icon: 'Image ',
			},
			tables: {
				id: 'tables',
				text: 'Tables',
				path: 'content/tables',
				icon: 'table_chart',
			},
			figures: {
				id: 'figures',
				text: 'Figures',
				path: 'content/figures',
				icon: 'Photo Library ',
			},
		},
	},
	utilities: {
		id: 'utilities',
		text: 'Utilities',
		path: 'utilities',
		icon: 'Support',
		subMenu: {
			api: {
				id: 'api',
				text: 'API',
				path: 'utilities/api',
				icon: 'Api',
			},
			background: {
				id: 'background',
				text: 'Background',
				path: 'utilities/background',
				icon: 'FormatColorFill',
			},
			borders: {
				id: 'borders',
				text: 'Borders',
				path: 'utilities/borders',
				icon: 'BorderStyle',
			},
			colors: {
				id: 'colors',
				text: 'Colors',
				path: 'utilities/colors',
				icon: 'InvertColors',
			},
			display: {
				id: 'display',
				text: 'Display',
				path: 'utilities/display',
				icon: 'LaptopMac',
			},
			flex: {
				id: 'flex',
				text: 'Flex',
				path: 'utilities/flex',
				icon: 'SettingsOverscan',
			},
			float: {
				id: 'float',
				text: 'Float',
				path: 'utilities/float',
				icon: 'ViewArray',
			},
			interactions: {
				id: 'interactions',
				text: 'Interactions',
				path: 'utilities/interactions',
				icon: 'Mouse',
			},
			overflow: {
				id: 'overflow',
				text: 'Overflow',
				path: 'utilities/overflow',
				icon: 'TableRows',
			},
			position: {
				id: 'position',
				text: 'Position',
				path: 'utilities/position',
				icon: 'Adjust',
			},
			shadows: {
				id: 'shadows',
				text: 'Shadows',
				path: 'utilities/shadows',
				icon: 'ContentCopy',
			},
			sizing: {
				id: 'sizing',
				text: 'Sizing',
				path: 'utilities/sizing',
				icon: 'Straighten',
			},
			spacing: {
				id: 'spacing',
				text: 'Spacing',
				path: 'utilities/spacing',
				icon: 'SpaceBar',
			},
			text: {
				id: 'text',
				text: 'Text',
				path: 'utilities/text',
				icon: 'TextFields',
			},
			verticalAlign: {
				id: 'vertical-align',
				text: 'Vertical Align',
				path: 'utilities/vertical-align',
				icon: 'VerticalAlignCenter',
			},
			visibility: {
				id: 'visibility',
				text: 'Visibility',
				path: 'utilities/visibility',
				icon: 'Visibility',
			},
		},
	},
	extra: {
		id: 'extra',
		text: 'Extra Library',
		icon: 'Extension',
		path: undefined,
	},
	icons: {
		id: 'icons',
		text: 'Icons',
		path: 'icons',
		icon: 'Grain',
		notification: 'success',
		subMenu: {
			icon: {
				id: 'icon',
				text: 'Icon',
				path: 'icons/icon',
				icon: 'Lightbulb',
			},
			material: {
				id: 'material',
				text: 'Material',
				path: 'icons/material',
				icon: 'Verified',
			},
		},
	},
	charts: {
		id: 'charts',
		text: 'Charts',
		path: 'charts',
		icon: 'AreaChart',
		notification: 'success',
		subMenu: {
			chartsUsage: {
				id: 'chartsUsage',
				text: 'General Usage',
				path: 'charts/general-usage',
				icon: 'Description',
			},
			chartsSparkline: {
				id: 'chartsSparkline',
				text: 'Sparkline',
				path: 'charts/sparkline',
				icon: 'AddChart',
			},
			chartsLine: {
				id: 'chartsLine',
				text: 'Line',
				path: 'charts/line',
				icon: 'ShowChart',
			},
			chartsArea: {
				id: 'chartsArea',
				text: 'Area',
				path: 'charts/area',
				icon: 'AreaChart',
			},
			chartsColumn: {
				id: 'chartsColumn',
				text: 'Column',
				path: 'charts/column',
				icon: 'BarChart',
			},
			chartsBar: {
				id: 'chartsBar',
				text: 'Bar',
				path: 'charts/bar',
				icon: 'StackedBarChart',
			},
			chartsMixed: {
				id: 'chartsMixed',
				text: 'Mixed',
				path: 'charts/mixed',
				icon: 'MultilineChart',
			},
			chartsTimeline: {
				id: 'chartsTimeline',
				text: 'Timeline',
				path: 'charts/timeline',
				icon: 'WaterfallChart',
			},
			chartsCandleStick: {
				id: 'chartsCandleStick',
				text: 'Candlestick',
				path: 'charts/candlestick',
				icon: 'Cake',
			},
			chartsBoxWhisker: {
				id: 'chartsBoxWhisker',
				text: 'Box Whisker',
				path: 'charts/box-whisker',
				icon: 'SportsMma',
			},
			chartsPieDonut: {
				id: 'chartsPieDonut',
				text: 'Pie & Donut',
				path: 'charts/pie-donut',
				icon: 'PieChart',
			},
			chartsRadar: {
				id: 'chartsRadar',
				text: 'Radar',
				path: 'charts/radar',
				icon: 'BrightnessLow',
			},
			chartsPolar: {
				id: 'chartsPolar',
				text: 'Polar',
				path: 'charts/polar',
				icon: 'TrackChanges',
			},
			chartsRadialBar: {
				id: 'chartsRadialBar',
				text: 'Radial Bar',
				path: 'charts/radial-bar',
				icon: 'DonutLarge',
			},
			chartsBubble: {
				id: 'chartsBubble',
				text: 'Bubble',
				path: 'charts/bubble',
				icon: 'BubbleChart',
			},
			chartsScatter: {
				id: 'chartsScatter',
				text: 'Scatter',
				path: 'charts/scatter',
				icon: 'ScatterPlot',
			},
			chartsHeatMap: {
				id: 'chartsHeatMap',
				text: 'Heat Map',
				path: 'charts/heat-map',
				icon: 'GridOn',
			},
			chartsTreeMap: {
				id: 'chartsTreeMap',
				text: 'Tree Map',
				path: 'charts/tree-map',
				icon: 'AccountTree',
			},
		},
	},
	notification: {
		id: 'notification',
		text: 'Notification',
		path: 'notifications',
		icon: 'NotificationsNone',
	},
	hooks: {
		id: 'hooks',
		text: 'Hooks',
		path: 'hooks',
		icon: 'Anchor',
	},
};

export const productsExampleMenu = {
	companyA: { id: 'companyA', text: 'Company A', path: 'grid-pages/products', subMenu: null },
	companyB: { id: 'companyB', text: 'Company B', path: '/', subMenu: null },
	companyC: { id: 'companyC', text: 'Company C', path: '/', subMenu: null },
	companyD: { id: 'companyD', text: 'Company D', path: '/', subMenu: null },
};
